import React, { Component } from "react";
import BsyDialog from "../BsyDialog";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyIconBtn from "../BsyIconBtn";
import BsySLoading from "../BsySLoading";
import BsyTextArea from "../BsyTextArea";

class ProjectSet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || {},
      appsMap: {},
      userSelectType: props.data.mode,
      installTime: props.data.limitDays === 0 ? 1 : 2,
      appIds: [],
      usersManagement: [],
      timeType: props.data.limitUnit === 1 ? "year" : props.data.limitUnit === 2 ? "month" : props.data.limitUnit === 3 ? "days" : "",
      isLoading: true,
      description: props.data.description || "",
    }
  }

  componentDidMount() {
    React.axios("/dashboard/standardapp_group/list").then(res => {
      let appsMap = {};
      res.data.items.map(item => {
        item.apps.map(app => {
          appsMap[app._id] = app;
        })
      })
      this.setState({ appsMap, isLoading: false })
    })
  }

  selectTime = (event) => {
    const e = event.currentTarget;
    const menu = [
      {
        text: React.language('days'),
        colorType: "",
        click: () => {
          this.setState({ timeType: "days" })
        }
      }, {
        text: React.language('month'),
        colorType: "",
        click: () => {
          this.setState({ timeType: "month" })
        }
      }, {
        text: React.language('year'),
        colorType: "",
        click: () => {
          this.setState({ timeType: "year" })
        }
      },
    ]
    e.classList.add("select");
    BsyAlertMenu({
      item: menu,
      width: 160,
      target: event.target,
      customCls: "import-export-item",
      onClose: () => {
        e.classList.remove("select")
      }
    })
  }

  addChangeDateTime = (e) => {
    this.addDateTime = e.target.value;
  }

  downloadApp = () => {
    const {data} = this.state;
    window.open(`/dashboard/standard_app_down/${data._id}/${data.version}`);
  }

  render() {
    const { userSelectType, installTime, timeType, data, appsMap, isLoading, description } = this.state;
    return <div className="ProjectSet">
      {isLoading && <BsySLoading style={{ background: '#ffffff' }} />}
      <div className="ProjectSetBody">
        <div className="projectTitle">
          {React.language("project.info")}
        </div>
        <div className="addItem name">
          <div className="itemTitle">
            <span>{React.language('Project.name')}</span>
          </div>
          <div className="itemValue">
            <div className="value-name">{data.name}</div>
          </div>
        </div>
        <div className="addItem version">
          <div className="itemTitle">
            <span>{React.language('project.version')}</span>
          </div>
          <div className="itemValue">
            <div className="value-version">{data.version}<span className="download" onClick={this.downloadApp}>{React.language('Download')}</span></div>
          </div>
        </div>
        <div className="addItem remark">
          <div className="itemTitle" style={{ paddingTop: 8 }}>
            <span>{React.language('Select.release.standard.app')}</span>
          </div>
          <div className="itemValue">
            <div className="apps-cont">
              {
                data.apps.map(res => {
                  const app = appsMap[res];
                  return app && <div className="app-item" key={res}>
                    <div className="app-icon">
                      <div className={`icon-backgroup color-cover-${app.style.color}`}>
                        <div className={`imgbg-bsy-app imgbg-bsy-app-${app.style.icon}`}></div>
                      </div>
                    </div>
                    <div className="app-name">{app.appname}</div>
                  </div>
                })
              }
            </div>
          </div>
        </div>
        <div className="addItem remark" style={{ marginBottom: 30 }}>
          <div className="itemTitle">
            <span>{React.language('Project.remark')}</span>
          </div>
          <div className="itemValue">
            <div className="value-remark">{data.remark}</div>
          </div>
        </div>
        <div className="projectTitle">
          {React.language("project.set")}
        </div>
        <div className="lineAddItem">
          <div className="itemValue">
            <div className="item-line">
              <div className="line-title">{React.language('select.user.install')}</div>
              <div className="line-value">
                <div className="value-radio-cont">
                  <div className={`radio-item ${userSelectType !== 1 ? "select" : ""}`} onClick={() => {
                    this.setState({ userSelectType: 2 })
                  }}>
                    <i className="icon-bsy-icondanxuananniu"></i>
                    <span>{React.language('allow.anyone.install')}</span>
                  </div>
                  <div className={`radio-item ${userSelectType === 1 ? "select" : ""}`} onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    this.setState({ userSelectType: 1 })
                  }}>
                    <i className="icon-bsy-icondanxuananniu"></i>
                    <span>{React.language('only.allow.user.install')}</span>
                    <span className="item-msg">{React.language('only.allow.user.install.msg')}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="item-line">
              <div className="line-title">{React.language('trial.time.after.first.installation')}</div>
              <div className="line-value">
                <div className="value-radio-cont">
                  <div className={`radio-item ${installTime !== 1 ? "select" : ""}`} onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    this.setState({ installTime: 2 })
                  }}>
                    <i className="icon-bsy-icondanxuananniu"></i>
                    <div className="selectTime" onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}>
                      <input type="number" max="99999" min="1" defaultValue={data.limitDays <= 0 ? "" : data.limitDays} onChange={this.addChangeDateTime} />
                      <div className="timeType" onClick={this.selectTime}>
                        <span>{React.language(timeType)}</span>
                        <i className="icon-bsy-xia"></i>
                      </div>
                    </div>
                  </div>
                  <div className={`radio-item ${installTime === 1 ? "select" : ""}`} onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    this.setState({ installTime: 1 })
                  }}>
                    <i className="icon-bsy-icondanxuananniu"></i>
                    <span>{React.language('not.limited')}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="item-line" >
              <div className="line-title">{React.language('installation.notes')}：</div>
              <div className="line-value" style={{ flex: 1 }}>
                <div className="value-radio-cont">
                  <BsyTextArea
                    value={description}
                    onStopEdit={(val) => {
                      this.setState({ description: val })
                    }}
                    width={"100%"}
                    height={80}
                    autoHeight={true}
                    hint={React.language('installation.notes.placeholder')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ProjectSetFooter">
        <BsyIconBtn
          text={React.language("save")}
          click={(event) => {
            this.setState({ isLoading: true }, () => {
              React.axios("/dashboard/standard_update", {
                "_id": data._id,
                "mode": this.state.userSelectType,
                "limitDays": this.addDateTime,
                "limitUnit": this.state.timeType === "year" ? 1 : this.state.timeType === "month" ? 2 : 3,
                "description": this.state.description
              }).then(res => {
                this.props.loadListData(!1, !0);
                this.setState({ isLoading: false })
              }).catch(() => {
                this.setState({ isLoading: false })
              })
            })
          }}
          type={"blue"}
          mode={window.mode}
        />
      </div>
    </div>
  }
}

export default ProjectSet;